// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__az_Fu","title":"Images45_title__17QZZ","images":"Images45_images__yv1Jc"};